// extracted by mini-css-extract-plugin
export default {"content":"HostIdDetailsModalContent_content__jjjPo"};